
import { SharingSettings } from '../types/sharingTypes';

export const generateShareCode = (): string => {
  return crypto.randomUUID();
};

export const createSharingSettings = (
  visibility: 'private' | 'shareable' | 'public',
  publicTitle?: string
): SharingSettings => {
  const settings: SharingSettings = {
    visibility,
    view_count: 0
  };

  if (visibility === 'shareable' || visibility === 'public') {
    settings.share_code = generateShareCode();
    settings.shared_at = new Date().toISOString();
  }

  if (visibility === 'public' && publicTitle) {
    settings.public_title = publicTitle;
  }

  return settings;
};

export const sanitizeForPublicSharing = (campaign: any): any => {
  // Remove sensitive information for public sharing
  const sanitized = {
    id: campaign.id,
    core_issue_details: {
      campaign_name: campaign.sharing_settings?.public_title || campaign.core_issue_details?.campaign_name,
      campaign_type: campaign.core_issue_details?.campaign_type,
      political_issue: campaign.core_issue_details?.political_issue,
      target_entity: campaign.core_issue_details?.target_entity,
      issue_description: campaign.core_issue_details?.issue_description
    },
    campaign_outcome: campaign.campaign_outcome,
    analysisState: {
      isComplete: campaign.analysisState?.isComplete,
      steps: campaign.analysisState?.steps?.map((step: any) => ({
        id: step.id,
        title: step.title,
        description: step.description,
        status: step.status,
        stage: step.stage,
        result: step.result
      })),
      consolidatedReport: campaign.analysisState?.consolidatedReport
    },
    sharing_settings: campaign.sharing_settings,
    created_at: campaign.createdAt
  };

  return sanitized;
};

export const canAccessCampaign = (
  campaign: any, 
  userId?: string, 
  shareCode?: string
): boolean => {
  // Owner can always access
  if (userId && campaign.userId === userId) {
    return true;
  }

  // Public campaigns are accessible to all
  if (campaign.sharing_settings?.visibility === 'public') {
    return true;
  }

  // Shareable campaigns with valid share code
  if (
    campaign.sharing_settings?.visibility === 'shareable' && 
    shareCode && 
    campaign.sharing_settings?.share_code === shareCode
  ) {
    return true;
  }

  return false;
};
